import { render, staticRenderFns } from "./AccountLinkBridge.vue?vue&type=template&id=9272da40&scoped=true&"
import script from "./AccountLinkBridge.vue?vue&type=script&lang=js&"
export * from "./AccountLinkBridge.vue?vue&type=script&lang=js&"
import style0 from "./AccountLinkBridge.vue?vue&type=style&index=0&id=9272da40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9272da40",
  null
  
)

export default component.exports